import { upperFirst } from 'lodash';
import { createTheme } from '@mui/material/styles';
import { lightTheme, tokens } from '@gojitsu/web-ui-core';

const AIR_SHOP = 'airShop';
const JLUX = 'jlux';

const generateThemeUtilities = (colors) => {
  const utilities = {};

  Object.keys(colors).forEach((key) => {
    const upperKey = upperFirst(key);
    utilities[`text${upperKey}`] = { color: colors[key] };
    utilities[`border${upperKey}`] = { borderColor: colors[key] };
    utilities[`bg${upperKey}`] = { backgroundColor: colors[key] };
  });

  const fontWeights = [300, 400, 500, 600, 700, 800, 900];

  fontWeights.forEach((fontWeight) => {
    utilities[`fontWeight${fontWeight}`] = { fontWeight: fontWeight };
  });

  return utilities;
};

export const colorUtilities = generateThemeUtilities(lightTheme.colorTokens);

const generateThemeProfileOptions = (profile) => {
  const options = {
    ...lightTheme,
    manageDeliveryLeft: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: lightTheme.palette.primary.contrastText,
      backgroundImage: `linear-gradient(${lightTheme.palette.primary.main}, ${lightTheme.palette.primary.main})`,
    },
    colors: {
      common1: tokens.neutral.neutral30,
      common2: tokens.neutral.neutral99,
      common3: tokens.neutral.neutral50,
      common4: tokens.neutral.neutral75,
      common5: lightTheme.colorTokens.surface,
      common6: lightTheme.colorTokens.onSecondaryFixedVariant,
      common7: lightTheme.colorTokens.success,
      common8: lightTheme.colorTokens.success,
      common9: lightTheme.colorTokens.onSecondaryFixedVariant,
      common10: lightTheme.palette.error.main,
      common11: lightTheme.colorTokens.surfaceContainerLowest,
      common12: tokens.neutral.neutral35,
      common13: lightTheme.palette.primary.main,
      common14: lightTheme.palette.primary.main,
      common15: tokens.neutral.neutral35,
    },
    colorTokens: lightTheme.colorTokens,
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  };

  options.colorUtilities = colorUtilities;

  if (profile === AIR_SHOP) {
    return {
      ...options,
      palette: { ...options.palette, primary: { main: '#0B071E', contrastText: '#ffffff' }, secondary: { main: '#E15EC4', contrastText: '#ffffff' } },
      manageDeliveryLeft: { ...options.manageDeliveryLeft, backgroundImage: 'linear-gradient(107deg, #0B071E 4%, #E15EC4 180%)' },
      typography: { fontFamily: ['ABCGintoNormalVariable'].join(',') },
      colors: {
        common1: '#4a4a4a',
        common2: '#fafafa',
        common3: '#868686',
        common4: '#b7b6b7',
        common5: '#0B071E',
        common6: '#0B071E',
        common7: '#E15EC4',
        common8: '#9f97ff',
        common9: '#6c62f5',
        common10: '#d0021b',
        common11: '#ffffff',
        common12: '#5a5a5a',
        common13: '#E15EC4',
        common14: '#E15EC4',
        common15: '#ffffff',
      },
    };
  }

  if (profile === JLUX) {
    return {
      ...options,
      colors: { ...options.colors, common6: '#000' },
    };
  }

  return options;
};

export const defaultTheme = createTheme(generateThemeProfileOptions());

export const airShop = createTheme(generateThemeProfileOptions(AIR_SHOP));

export const jlux = createTheme(generateThemeProfileOptions(JLUX));
